export const msps = [
  {
    name: "George Adam",
    constituency: "Paisley",
    party: "SNP",
    handle: "@GeorgeAdam",
    email: "george.adam.msp@parliament.scot",
  },
  {
    name: "Karen Adam",
    constituency: "Banffshire and Buchan Coast",
    party: "SNP",
    handle: "none",
    email: "karen.adam.msp@parliament.scot",
  },
  {
    name: "Clare Adamson",
    constituency: "Motherwell and Wishaw",
    party: "SNP",
    handle: "@ClareAdamsonSNP",
    email: "clare.adamson.msp@parliament.scot",
  },
  {
    name: "Alasdair Allan",
    constituency: "Na h-Eileanan an Iar",
    party: "SNP",
    handle: "@alasdairallan",
    email: "alasdair.allan.msp@parliament.scot",
  },
  {
    name: "Tom Arthur",
    constituency: "Renfrewshire South",
    party: "SNP",
    handle: "@ThomasCArthur",
    email: "tom.arthur.msp@parliament.scot",
  },
  {
    name: "Jackie Baillie",
    constituency: "Dumbarton",
    party: "Labour",
    handle: "@jackiebmsp",
    email: "jackie.baillie.msp@parliament.scot",
  },
  {
    name: "Claire Baker",
    constituency: "Mid Scotland and Fife",
    party: "Labour",
    handle: "@clairebakermsp",
    email: "claire.baker.msp@parliament.scot",
  },
  {
    name: "Jeremy Balfour",
    constituency: "Lothian",
    party: "Tory",
    handle: "@JeremyRBalfour",
    email: "jeremy.balfour.msp@parliament.scot",
  },
  {
    name: "Colin Beattie",
    constituency: "Midlothian North and Musselburgh",
    party: "SNP",
    handle: "@uartlach",
    email: "colin.beattie.msp@parliament.scot",
  },
  {
    name: "Neil Bibby",
    constituency: "West Scotland",
    party: "Labour",
    handle: "@NeilBibby",
    email: "neil.bibby.msp@parliament.scot",
  },
  {
    name: "Sarah Boyack",
    constituency: "Lothian",
    party: "Labour",
    handle: "@SarahBoyack",
    email: "sarah.boyack.msp@parliament.scot",
  },
  {
    name: "Miles Briggs",
    constituency: "Lothian",
    party: "Tory",
    handle: "@Miles4Lothian",
    email: "miles.briggs.msp@parliament.scot",
  },
  {
    name: "Keith Brown",
    constituency: "Clackmannanshire and Dunblane",
    party: "SNP",
    handle: "@KeithBrownSNP",
    email: "keith.brown.msp@parliament.scot",
  },
  {
    name: "Siobhian Brown",
    constituency: "Ayr",
    party: "SNP",
    handle: "@Siobhianayr",
    email: "siobhian.brown.msp@parliament.scot",
  },
  {
    name: "Ariane Burgess",
    constituency: "Highlands and Islands",
    party: "Green",
    handle: "@ArianeBurgessHI",
    email: "ariane.burgess.msp@parliament.scot",
  },
  {
    name: "Alexander Burnett",
    constituency: "Aberdeenshire West",
    party: "Tory",
    handle: "@AJABurnett",
    email: "alexander.burnett.msp@parliament.scot",
  },
  {
    name: "Stephanie Callaghan",
    constituency: "Uddingston and Bellshill",
    party: "SNP",
    handle: "@StephySNP",
    email: "stephanie.callaghan.msp@parliament.scot",
  },
  {
    name: "Donald Cameron",
    constituency: "Highlands and Islands",
    party: "Tory",
    handle: "@DAJCameron",
    email: "donald.cameron.msp@parliament.scot",
  },
  {
    name: "Jackson Carlaw",
    constituency: "Eastwood",
    party: "Tory",
    handle: "@Jackson_Carlaw",
    email: "jackson.carlaw.msp@parliament.scot",
  },
  {
    name: "Finlay Carson",
    constituency: "Galloway and West Dumfries",
    party: "Tory",
    handle: "@fincarson",
    email: "finlay.carson.msp@parliament.scot",
  },
  {
    name: "Maggie Chapman",
    constituency: "North East Scotland",
    party: "Green",
    handle: "@MaggieChapman",
    email: "maggie.chapman.msp@parliament.scot",
  },
  {
    name: "Foysol Choudhury",
    constituency: "Lothian",
    party: "Labour",
    handle: "@FoysolChoudhury",
    email: "foysol.choudhury.msp@parliament.scot",
  },
  {
    name: "Katy Clark",
    constituency: "West Scotland",
    party: "Labour",
    handle: "@KatySClark",
    email: "katy.clark.msp@parliament.scot",
  },
  {
    name: "Willie Coffey",
    constituency: "Kilmarnock and Irvine Valley",
    party: "SNP",
    handle: "@williecoffeysnp",
    email: "willie.coffey.msp@parliament.scot",
  },
  {
    name: "Alex Cole-Hamilton",
    constituency: "Edinburgh Western",
    party: "LibDem",
    handle: "@agcolehamilton",
    email: "alex.cole-hamilton.msp@parliament.scot",
  },
  {
    name: "Angela Constance",
    constituency: "Almond Valley",
    party: "SNP",
    handle: "@AConstanceSNP",
    email: "angela.constance.msp@parliament.scot",
  },
  {
    name: "Ash Regan",
    constituency: "Edinburgh Eastern",
    party: "SNP",
    handle: "@AshtenRegan",
    email: "ash.regan.msp@parliament.scot",
  },
  {
    name: "Graeme Dey",
    constituency: "Angus South",
    party: "SNP",
    handle: "none",
    email: "graeme.dey.msp@parliament.scot",
  },
  {
    name: "Natalie Don",
    constituency: "Renfrewshire North and West",
    party: "SNP",
    handle: "@NatalieDon_",
    email: "natalie.don.msp@parliament.scot",
  },
  {
    name: "Bob Doris",
    constituency: "Glasgow Maryhill and Springburn",
    party: "SNP",
    handle: "@BobDorisSNP",
    email: "bob.doris.msp@parliament.scot",
  },
  {
    name: "James Dornan",
    constituency: "Glasgow Cathcart",
    party: "SNP",
    handle: "@glasgowcathcart",
    email: "james.dornan.msp@parliament.scot",
  },
  {
    name: "Sharon Dowey",
    constituency: "South Scotland",
    party: "Tory",
    handle: "@SharonDowey_",
    email: "sharon.dowey.msp@parliament.scot",
  },
  {
    name: "Jackie Dunbar",
    constituency: "Aberdeen Donside",
    party: "SNP",
    handle: "@JackieDunbarSNP",
    email: "jackie.dunbar.msp@parliament.scot",
  },
  {
    name: "Pam Duncan-Glancy",
    constituency: "Glasgow",
    party: "Labour",
    handle: "@GlasgowPam",
    email: "pam.duncan-glancy.msp@parliament.scot",
  },
  {
    name: "Annabelle Ewing",
    constituency: "Cowdenbeath",
    party: "SNP",
    handle: "@aewing4Cbeath",
    email: "annabelle.ewing.msp@parliament.scot",
  },
  {
    name: "Fergus Ewing",
    constituency: "Inverness and Nairn",
    party: "SNP",
    handle: "@FergusEwingSNP",
    email: "fergus.ewing.msp@parliament.scot",
  },
  {
    name: "Jim Fairlie",
    constituency: "Perthshire South and Kinross-shire",
    party: "SNP",
    handle: "@JimFairlieLogie",
    email: "jim.fairlie.msp@parliament.scot",
  },
  {
    name: "Russell Findlay",
    constituency: "West Scotland",
    party: "Tory",
    handle: "@RussellFindlay1",
    email: "russell.findlay.msp@parliament.scot",
  },
  {
    name: "Joe FitzPatrick",
    constituency: "Dundee City West",
    party: "SNP",
    handle: "@JoeFitzSNP",
    email: "joe.fitzpatrick.msp@parliament.scot",
  },
  {
    name: "Kate Forbes",
    constituency: "Skye, Lochaber and Badenoch",
    party: "SNP",
    handle: "@_KateForbes",
    email: "kate.forbes.msp@parliament.scot",
  },
  {
    name: "Murdo Fraser",
    constituency: "Mid Scotland and Fife",
    party: "Tory",
    handle: "@murdo_fraser",
    email: "murdo.fraser.msp@parliament.scot",
  },
  {
    name: "Meghan Gallacher",
    constituency: "Central Scotland",
    party: "Tory",
    handle: "@MGallacherMSP",
    email: "meghan.gallacher.msp@parliament.scot",
  },
  {
    name: "Kenneth Gibson",
    constituency: "Cunninghame North",
    party: "SNP",
    handle: "none",
    email: "kenneth.gibson.msp@parliament.scot",
  },
  {
    name: "Jenny Gilruth",
    constituency: "Mid Fife and Glenrothes",
    party: "SNP",
    handle: "@JennyGilruth",
    email: "jenny.gilruth.msp@parliament.scot",
  },
  {
    name: "Maurice Golden",
    constituency: "North East Scotland",
    party: "Tory",
    handle: "@mgoldenmsp",
    email: "maurice.golden.msp@parliament.scot",
  },
  {
    name: "Pam Gosal",
    constituency: "West Scotland",
    party: "Tory",
    handle: "@PamGosalMSP",
    email: "pam.gosal.msp@parliament.scot",
  },
  {
    name: "Mairi Gougeon",
    constituency: "Angus North and Mearns",
    party: "SNP",
    handle: "@MairiGougeon",
    email: "mairi.gougeon.msp@parliament.scot",
  },
  {
    name: "Christine Grahame",
    constituency: "Midlothian South, Tweeddale and Lauderdale",
    party: "SNP",
    handle: "@CGrahameMSP",
    email: "christine.grahame.msp@parliament.scot",
  },
  {
    name: "Rhoda Grant",
    constituency: "Highlands and Islands",
    party: "Labour",
    handle: "@RhodaGrant",
    email: "rhoda.grant.msp@parliament.scot",
  },
  {
    name: "Neil Gray",
    constituency: "Airdrie and Shotts",
    party: "SNP",
    handle: "@neilgraysnp",
    email: "neil.gray.msp@parliament.scot",
  },
  {
    name: "Jamie Greene",
    constituency: "West Scotland",
    party: "Tory",
    handle: "@jamiegreeneUK",
    email: "jamie.greene.msp@parliament.scot",
  },
  {
    name: "Ross Greer",
    constituency: "West Scotland",
    party: "Green",
    handle: "@Ross_Greer",
    email: "ross.greer.msp@parliament.scot",
  },
  {
    name: "Mark Griffin",
    constituency: "Central Scotland",
    party: "Labour",
    handle: "@MarkGriff1n",
    email: "mark.griffin.msp@parliament.scot",
  },
  {
    name: "Sandesh Gulhane",
    constituency: "Glasgow",
    party: "Tory",
    handle: "@Sandeshgulhane",
    email: "sandesh.gulhane.msp@parliament.scot",
  },
  {
    name: "Jamie Halcro Johnston",
    constituency: "Highlands and Islands",
    party: "Tory",
    handle: "@jhalcrojohnston",
    email: "jamie.halcro.johnston.msp@parliament.scot",
  },
  {
    name: "Rachael Hamilton",
    constituency: "Ettrick, Roxburgh and Berwickshire",
    party: "Tory",
    handle: "@Rachael2Win",
    email: "rachael.hamilton.msp@parliament.scot",
  },
  {
    name: "Emma Harper",
    constituency: "South Scotland",
    party: "SNP",
    handle: "@EmmaHarperMSP",
    email: "emma.harper.msp@parliament.scot",
  },
  {
    name: "Patrick Harvie",
    constituency: "Glasgow",
    party: "Green",
    handle: "@patrickharvie",
    email: "patrick.harvie.msp@parliament.scot",
  },
  {
    name: "Clare Haughey",
    constituency: "Rutherglen",
    party: "SNP",
    handle: "@haughey_clare",
    email: "clare.haughey.msp@parliament.scot",
  },
  {
    name: "Jamie Hepburn",
    constituency: "Cumbernauld and Kilsyth",
    party: "SNP",
    handle: "@jamiehepburn",
    email: "jamie.hepburn.msp@parliament.scot",
  },
  {
    name: "Craig Hoy",
    constituency: "South Scotland",
    party: "Tory",
    handle: "@CraigWHoy1",
    email: "craig.hoy.msp@parliament.scot",
  },
  {
    name: "Fiona Hyslop",
    constituency: "Linlithgow",
    party: "SNP",
    handle: "@FionaHyslop",
    email: "fiona.hyslop.msp@parliament.scot",
  },
  {
    name: "Daniel Johnson",
    constituency: "Edinburgh Southern",
    party: "Labour",
    handle: "@djohnsonmsp",
    email: "daniel.johnson.msp@parliament.scot",
  },
  {
    name: "Alison Johnstone",
    constituency: "Lothian",
    party: "Presiding Officer",
    handle: "@POScotParl",
    email: "alison.johnstone.msp@parliament.scot",
  },
  {
    name: "Liam Kerr",
    constituency: "North East Scotland",
    party: "Tory",
    handle: "@LiamKerrMSP",
    email: "liam.kerr.msp@parliament.scot",
  },
  {
    name: "Stephen Kerr",
    constituency: "Central Scotland",
    party: "Tory",
    handle: "@RealStephenKerr",
    email: "stephen.kerr.msp@parliament.scot",
  },
  {
    name: "Bill Kidd",
    constituency: "Glasgow Anniesland",
    party: "SNP",
    handle: "@BillKiddSNP",
    email: "bill.kidd.msp@parliament.scot",
  },
  {
    name: "Monica Lennon",
    constituency: "Central Scotland",
    party: "Labour",
    handle: "@MonicaLennon7",
    email: "monica.lennon.msp@parliament.scot",
  },
  {
    name: "Richard Leonard",
    constituency: "Central Scotland",
    party: "Labour",
    handle: "@LabourRichard",
    email: "richard.leonard.msp@parliament.scot",
  },
  {
    name: "Richard Lochhead",
    constituency: "Moray",
    party: "SNP",
    handle: "@RichardLochhead",
    email: "richard.lochhead.msp@parliament.scot",
  },
  {
    name: "Douglas Lumsden",
    constituency: "North East Scotland",
    party: "Tory",
    handle: "@dlumsden",
    email: "douglas.lumsden.msp@parliament.scot",
  },
  {
    name: "Gordon MacDonald",
    constituency: "Edinburgh Pentlands",
    party: "SNP",
    handle: "@GMacdonaldSNP",
    email: "gordon.macdonald.msp@parliament.scot",
  },
  {
    name: "Fulton MacGregor",
    constituency: "Coatbridge and Chryston",
    party: "SNP",
    handle: "@fultonsnp",
    email: "fulton.macgregor.msp@parliament.scot",
  },
  {
    name: "Gillian Mackay",
    constituency: "Central Scotland",
    party: "Green",
    handle: "@GillianMacMSP",
    email: "gillian.mackay.msp@parliament.scot",
  },
  {
    name: "Rona Mackay",
    constituency: "Strathkelvin and Bearsden",
    party: "SNP",
    handle: "@RonaMackaySNP",
    email: "rona.mackay.msp@parliament.scot",
  },
  {
    name: "Ben Macpherson",
    constituency: "Edinburgh Northern and Leith",
    party: "SNP",
    handle: "@BenMacpherson",
    email: "ben.macpherson.msp@parliament.scot",
  },
  {
    name: "Ruth Maguire",
    constituency: "Cunninghame South",
    party: "SNP",
    handle: "@RBFMaguire",
    email: "ruth.maguire.msp@parliament.scot",
  },
  {
    name: "Michael Marra",
    constituency: "North East Scotland",
    party: "Labour",
    handle: "@michaeljmarra",
    email: "michael.marra.msp@parliament.scot",
  },
  {
    name: "Gillian Martin",
    constituency: "Aberdeenshire East",
    party: "SNP",
    handle: "@GillianMSP",
    email: "gillian.martin.msp@parliament.scot",
  },
  {
    name: "John Mason",
    constituency: "Glasgow Shettleston",
    party: "SNP",
    handle: "@JohnMasonMSP",
    email: "john.mason.msp@parliament.scot",
  },
  {
    name: "Michael Matheson",
    constituency: "Falkirk West",
    party: "SNP",
    handle: "@MathesonMichael",
    email: "michael.matheson.msp@parliament.scot",
  },
  {
    name: "Màiri McAllan",
    constituency: "Clydesdale",
    party: "SNP",
    handle: "@MairiMcAllan",
    email: "màiri.mcallan.msp@parliament.scot",
  },
  {
    name: "Liam McArthur",
    constituency: "Orkney",
    party: "LibDem",
    handle: "@Liam4Orkney",
    email: "liam.mcarthur.msp@parliament.scot",
  },
  {
    name: "Roz McCall",
    constituency: '"Mid Scotland and Fife',
    party: "Tory",
    handle: "@RozMccall",
    email: "roz.mccall.msp@parliament.scot",
  },
  {
    name: "Ivan McKee",
    constituency: "Glasgow Provan",
    party: "SNP",
    handle: "@Ivan_McKee",
    email: "ivan.mckee.msp@parliament.scot",
  },
  {
    name: "Christina McKelvie",
    constituency: "Hamilton, Larkhall and Stonehouse",
    party: "SNP",
    handle: "@ChristinaSNP",
    email: "christina.mckelvie.msp@parliament.scot",
  },
  {
    name: "Paul McLennan",
    constituency: "East Lothian",
    party: "SNP",
    handle: "@PaulMcLennan7",
    email: "paul.mclennan.msp@parliament.scot",
  },
  {
    name: "Stuart McMillan",
    constituency: "Greenock and Inverclyde",
    party: "SNP",
    handle: "@StuMcMillanSNP",
    email: "stuart.mcmillan.msp@parliament.scot",
  },
  {
    name: "Marie McNair",
    constituency: "Clydebank and Milngavie",
    party: "SNP",
    handle: "@MarieAMcNair",
    email: "marie.mcnair.msp@parliament.scot",
  },
  {
    name: "Pauline McNeill",
    constituency: "Glasgow",
    party: "Labour",
    handle: "@pauline4glasgow",
    email: "pauline.mcneill.msp@parliament.scot",
  },
  {
    name: "Jenni Minto",
    constituency: "Argyll and Bute",
    party: "SNP",
    handle: "@jenni_minto",
    email: "jenni.minto.msp@parliament.scot",
  },
  {
    name: "Carol Mochan",
    constituency: "South Scotland",
    party: "Labour",
    handle: "@CMochan",
    email: "carol.mochan.msp@parliament.scot",
  },
  {
    name: "Sir Edward Mountain",
    constituency: "Highlands and Islands",
    party: "Tory",
    handle: "@1edmountain",
    email: "sir.edward.mountain.msp@parliament.scot",
  },
  {
    name: "Oliver Mundell",
    constituency: "Dumfriesshire",
    party: "Tory",
    handle: "@olivermundell",
    email: "oliver.mundell.msp@parliament.scot",
  },
  {
    name: "Audrey Nicoll",
    constituency: "Aberdeen South and North Kincardine",
    party: "SNP",
    handle: "@Audrey4ASNK",
    email: "audrey.nicoll.msp@parliament.scot",
  },
  {
    name: "Paul O'Kane",
    constituency: "West Scotland",
    party: "Labour",
    handle: "@PFOKane",
    email: "paul.o'kane.msp@parliament.scot",
  },
  {
    name: "Willie Rennie",
    constituency: "North East Fife",
    party: "LibDem",
    handle: "@willie_rennie",
    email: "willie.rennie.msp@parliament.scot",
  },
  {
    name: "Angus Robertson",
    constituency: "Edinburgh Central",
    party: "SNP",
    handle: "@AngusRobertson",
    email: "angus.robertson.msp@parliament.scot",
  },
  {
    name: "Shona Robison",
    constituency: "Dundee City East",
    party: "SNP",
    handle: "@ShonaRobison",
    email: "shona.robison.msp@parliament.scot",
  },
  {
    name: "Emma Roddick",
    constituency: "Highlands and Islands",
    party: "SNP",
    handle: "@Emma_Roddick",
    email: "emma.roddick.msp@parliament.scot",
  },
  {
    name: "Douglas Ross",
    constituency: "Highlands and Islands",
    party: "Tory",
    handle: "@Douglas4Moray",
    email: "douglas.ross.msp@parliament.scot",
  },
  {
    name: "Alex Rowley",
    constituency: "Mid Scotland and Fife",
    party: "Labour",
    handle: "@AlexRowleyFife",
    email: "alex.rowley.msp@parliament.scot",
  },
  {
    name: "Mark Ruskell",
    constituency: "Mid Scotland and Fife",
    party: "Green",
    handle: "@markruskell",
    email: "mark.ruskell.msp@parliament.scot",
  },
  {
    name: "Anas Sarwar",
    constituency: "Glasgow",
    party: "Labour",
    handle: "@AnasSarwar",
    email: "anas.sarwar.msp@parliament.scot",
  },
  {
    name: "Graham Simpson",
    constituency: "Central Scotland",
    party: "Tory",
    handle: "@GrahamSMSP",
    email: "graham.simpson.msp@parliament.scot",
  },
  {
    name: "Lorna Slater",
    constituency: "Lothian",
    party: "Green",
    handle: "@lornaslater",
    email: "lorna.slater.msp@parliament.scot",
  },
  {
    name: "Liz Smith",
    constituency: "Mid Scotland and Fife",
    party: "Tory",
    handle: "@mspliz",
    email: "liz.smith.msp@parliament.scot",
  },
  {
    name: "Colin Smyth",
    constituency: "South Scotland",
    party: "Labour",
    handle: "@colinsmythmsp",
    email: "colin.smyth.msp@parliament.scot",
  },
  {
    name: "Shirley-Anne Somerville",
    constituency: "Dunfermline",
    party: "SNP",
    handle: "@S_A_Somerville",
    email: "shirley-anne.somerville.msp@parliament.scot",
  },
  {
    name: "Collette Stevenson",
    constituency: "East Kilbride",
    party: "SNP",
    handle: "@CStevensonSNP",
    email: "collette.stevenson.msp@parliament.scot",
  },
  {
    name: "Alexander Stewart",
    constituency: "Mid Scotland and Fife",
    party: "Tory",
    handle: "none",
    email: "alexander.stewart.msp@parliament.scot",
  },
  {
    name: "Kaukab Stewart",
    constituency: "Glasgow Kelvin",
    party: "SNP",
    handle: "@kaukabstewart",
    email: "kaukab.stewart.msp@parliament.scot",
  },
  {
    name: "Kevin Stewart",
    constituency: "Aberdeen Central",
    party: "SNP",
    handle: "@KevinStewartSNP",
    email: "kevin.stewart.msp@parliament.scot",
  },
  {
    name: "Nicola Sturgeon",
    constituency: "Glasgow Southside",
    party: "SNP",
    handle: "@NicolaSturgeon",
    email: "nicola.sturgeon.msp@parliament.scot",
  },
  {
    name: "Paul Sweeney",
    constituency: "Glasgow",
    party: "Labour",
    handle: "@PaulJSweeney",
    email: "paul.sweeney.msp@parliament.scot",
  },
  {
    name: "John Swinney",
    constituency: "Perthshire North",
    party: "SNP",
    handle: "@JohnSwinney",
    email: "john.swinney.msp@parliament.scot",
  },
  {
    name: "Michelle Thomson",
    constituency: "Falkirk East",
    party: "SNP",
    handle: "@MichelleThomson",
    email: "michelle.thomson.msp@parliament.scot",
  },
  {
    name: "Maree Todd",
    constituency: "Caithness, Sutherland and Ross",
    party: "SNP",
    handle: "@MareeToddMSP",
    email: "maree.todd.msp@parliament.scot",
  },
  {
    name: "David Torrance",
    constituency: "Kirkcaldy",
    party: "SNP",
    handle: "@DavidHTorrance",
    email: "david.torrance.msp@parliament.scot",
  },
  {
    name: "Evelyn Tweed",
    constituency: "Stirling",
    party: "SNP",
    handle: "@EvelynTweedSNP",
    email: "evelyn.tweed.msp@parliament.scot",
  },
  {
    name: "Mercedes Villalba",
    constituency: "North East Scotland",
    party: "Labour",
    handle: "@LabourMercedes",
    email: "mercedes.villalba.msp@parliament.scot",
  },
  {
    name: "Sue Webber",
    constituency: "Lothian",
    party: "Tory",
    handle: "@SueJWebber",
    email: "sue.webber.msp@parliament.scot",
  },
  {
    name: "Annie Wells",
    constituency: "Glasgow",
    party: "Tory",
    handle: "@AnnieWellsMSP",
    email: "annie.wells.msp@parliament.scot",
  },
  {
    name: "Tess White",
    constituency: "North East Scotland",
    party: "Tory",
    handle: "@TessWhite4NE",
    email: "tess.white.msp@parliament.scot",
  },
  {
    name: "Martin Whitfield",
    constituency: "South Scotland",
    party: "Labour",
    handle: "@_MWhitfield",
    email: "martin.whitfield.msp@parliament.scot",
  },
  {
    name: "Elena Whitham",
    constituency: "Carrick, Cumnock and Doon Valley",
    party: "SNP",
    handle: "@ElenaWhitham",
    email: "elena.whitham.msp@parliament.scot",
  },
  {
    name: "Brian Whittle",
    constituency: "South Scotland",
    party: "Tory",
    handle: "@BrianWhittle",
    email: "brian.whittle.msp@parliament.scot",
  },
  {
    name: "Beatrice Wishart",
    constituency: "Shetland",
    party: "LibDem",
    handle: "@BeatriceWishart",
    email: "beatrice.wishart.msp@parliament.scot",
  },
  {
    name: "Humza Yousaf",
    constituency: "Glasgow Pollok",
    party: "SNP",
    handle: "@HumzaYousaf",
    email: "humza.yousaf.msp@parliament.scot",
  },
];
